import { useContext } from "react";
import { CartContext } from "lib/cartContext";
import PropTypes from "prop-types";
import { useMutation } from "@apollo/client/react/hooks";
import { useFormContext } from "react-hook-form";
import { scrollToRef } from "helpers/utils";
import { scrollToField, formDataToVariables } from "helpers/product";

import { GetCart } from "../../../../helpers/api/cadeauConcepten/queries/cart.gql";
import { AddPackageToCart } from "../../../../helpers/api/cadeauConcepten/mutations/cart.gql";

import { AddPackageStyled, Icon } from "./AddPackage.styled";

export default function AddPackage({
    cartRef,
    configRef,
    quantityValueRef,
    personalMessageRef,
    packagingRef,
    giftWrapRef,
    upsellRef
}) {
    const { handleSubmit, reset, errors } = useFormContext();
    const { setAddingPackage } = useContext(CartContext);

    const [addPackage, { loading, error }] = useMutation(AddPackageToCart, {
        errorPolicy: "all",
        update: (cache, { data }) => {
            const { addPackageToCart } = data;

            if (addPackageToCart) {
                cache.writeQuery({
                    query: GetCart,
                    data: { cart: { ...addPackageToCart } }
                });
            }
        },
        onError: () => {
            setAddingPackage(false);
        },
        onCompleted: () => {
            setAddingPackage(false);
            reset({
                giftWrap: {
                    enabled: false
                },
                packaging: { checked: false, items: [] },
                personalMessage: {
                    checked: false,
                    message: ""
                },
                upsell: {
                    checked: false,
                    items: []
                }
            });
        }
    });
    const isDisabled = loading || error;

    function onError() {
        scrollToField(errors, {
            configRef,
            quantityValueRef,
            personalMessageRef,
            packagingRef,
            giftWrapRef,
            upsellRef
        });
    }

    function handleAddPackage(data) {
        setAddingPackage(true);

        const formattedData = formDataToVariables(data);

        addPackage(formattedData);

        if (cartRef && cartRef.current) {
            scrollToRef(cartRef);
        }
    }

    return (
        <AddPackageStyled
            type="button"
            onClick={handleSubmit(handleAddPackage, onError)}
            disabled={isDisabled}
        >
            <Icon
                src="/images/icon-plus.svg"
                alt="plus"
                width={21}
                height={21}
                loading="lazy"
            />
            Voeg nog een aantal kaarten toe met bijv. een andere waarde of
            verpakking.
        </AddPackageStyled>
    );
}

AddPackage.propTypes = {
    cartRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ]).isRequired,
    giftWrapRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ]).isRequired,
    quantityValueRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ]).isRequired,
    personalMessageRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ]).isRequired,
    packagingRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ]).isRequired,
    upsellRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ]).isRequired,
    configRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ]).isRequired
};
